<form [formGroup]="form" tabindex="-1">
  <div class="container">
    <div class="container-form">
      <div class="form-container">
        <div class="form-section">

          <div class="row">
            <div class="col-md-6 col-xs-12 box-center">
              <span class="label-file-name">
                {{label}}
                <span *ngIf="!required">(Opcional)</span>
              </span>

              <div>
                <ng-content select="[text]"></ng-content>
              </div>
            </div>
            <div class="col-md-6 col-xs-12 ">
              <div class="row">
                <div class="col-md-12 col-xs-12">
                  <div *ngIf="!attachments" class="form-container"  tabindex="-1">


                    <span class="form-item-file form-item-file-span">{{
                      fileAdjunt
                      }}</span>

                    <!-- [ngClass]="{'bloking-cursor': disabled,'bloking-cursor': disabled}"-->
                    <!--<label class="form-file-container"   aria-label = "Adjuntar">
                      <em class="material-icons" aria-hidden="true">cloud_upload</em>Adjuntar
                      <input  formControlName="attachment" type="file" [accept]="extPermit.toString()" class="{{nameclassInput}}" (change)="changeO()">
                    </label>-->

                    <label  class="form-file-container"  aria-label="Adjuntar">
                      <i tabindex="0" class="material-icons">cloud_upload</i>Adjuntar
                      <input tabindex="-1" formControlName="attachment" type="file" [accept]="extPermit.toString()" class="{{nameclassInput}}" (change)="changeO()"
                        />
                    </label>
                    <div *ngIf="errorFile" class="form-docs mg-top-0">
                      <span class="msn-error--inline is-inactive font-12 color-red">
                        Los documentos no deben superar los
                        {{ maxSizeAttachmentsKb }} kilobytes de tamaño
                      </span>
                    </div>
                    <div *ngIf="errorFileExt" class="form-docs mg-top-0">
                      <span class="msn-error--inline is-inactive font-12 color-red">
                        Los tipos de archivos permitidos son : {{ extPermit | json }}
                      </span>
                    </div>
                    <ng-content></ng-content>
                  </div>
                  <div class=" form-docs">
                    <span class="line-horizontal"></span>
                    <div *ngIf="attachments" class="row  file-info-container bg-white">
                      <div class="col-md-2 col-xs-4 col-sm-2" *ngIf="!isSave">
                        <div class="row file-actions line">
                          <span class="col-md-6 col-sm-6 col-xs-6 action-circle-icon" data-color="red"><i
                              class="material-icons">description</i></span>
                          <span class="col-md-6 col-sm-6 col-xs-6 action-circle-icon" data-color="red"><i
                              class="material-icons">close</i></span>
                        </div>
                      </div>
                      <div class="col-md-2 col-xs-4 col-sm-2" *ngIf="isSave">
                        <div class="row file-actions line">
                          <span class="col-md-6 col-sm-6 col-xs-6 action-circle-icon" data-color="blue"><i
                              class="material-icons">description</i></span>
                          <span class="col-md-6 col-sm-6 col-xs-6 action-circle-icon" data-color="green"><i
                              class="material-icons">done</i></span>
                        </div>
                      </div>
                      <div *ngIf="isSave" class="col-md-8 col-xs-8 col-sm-8 file-info">{{ attachments.nombre ?
                        attachments.nombre :
                        label
                        }}</div>

                      <div *ngIf="!isSave" class="col-md-6 col-xs-6 col-sm-6 file-info">{{ attachments.nombre ?
                        attachments.nombre :
                        label
                        }}</div>
                      <span *ngIf="!isSave" class="pointer col-md-4 col-xs-4 col-sm-4 btn-delete">
                        <label tabindex="0" aria-label="Volver a intentar" (click)="deleteFile()" class="custom-file-upload">
                          <i class="fa fa-cloud-upload"></i> Volver a intentar
                        </label>



                      </span>
                      <span tabindex="0" *ngIf="isSave" class="pointer col-md-2 col-xs-2 col-sm-2 btn-delete"><i
                          class="material-icons" (click)="deleteFile(attachments)">delete</i></span>
                    </div>

                  </div>
                  <div *ngIf="progress" tabindex="-1">
                    <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
                  </div>
                </div>
              </div>

            </div>



          </div>

        </div>
      </div>
    </div>
  </div>
</form>
